import ko from 'i18n/locales/ko.json'
import en from 'i18n/locales/en.json'
import ja from 'i18n/locales/ja.json'

export default {
  ko: {translation: ko},
  en: {translation: en},
  ja: {translation: ja},
} as const
